<form [formGroup]="configForm">
  <div class="form__field">
    <label for="header" class="input__label" i18n="@@powerbi_widget_config.header">Header</label>
    <input type="text" pInputText formControlName="header" />
  </div>
  <div class="form__field">
    <label for="url" class="input__label">Url</label>
    <input type="text" pInputText formControlName="url" />
  </div>
</form>
